import { render, staticRenderFns } from "./TempInvoicesSection.vue?vue&type=template&id=0780af5a&"
import script from "./TempInvoicesSection.vue?vue&type=script&lang=js&"
export * from "./TempInvoicesSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports